import React, { useState, useEffect } from 'react';
import { fetchStockSplitData } from './services/stockSplitCalenderService';
import AddStockSplitForm from './AddStockSplitForm';
import EditStockSplitForm from './EditStockSplitForm';
import Navbar from './navbar';
import Footer from './footer';
import { useNavigate } from 'react-router-dom';

const StockSplitCalendar = () => {
  const [data, setData] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [selectedItem, setSelectedItem] = useState(null); // For edit
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const result = await fetchStockSplitData(filterStatus);
      setData(result);
    } catch (error) {
      console.error('Error fetching stock split data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterStatus]);

  const handleAddClick = () => {
    setShowAddModal(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setShowEditModal(true);
  };

  const handleSourceClick = () => {
  
  };

  const closeModals = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    fetchData(); // Refresh data after adding/editing
  };

  const getUniqueCorporateActions = (data) => {
    return [...new Set(data.map((item) => item.corporateaction))];
  };

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page
  };

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between mb-3" style={{ marginBottom: '10px', marginTop: '10px' }}>
            <button className="btn btn-primary" onClick={() => navigate(-1)}>
              Back
            </button>
            <h4 className="fw-bold" style={{ fontFamily: 'Arial, sans-serif' }}>Stock Split Calendar</h4>
            <button className="btn btn-primary" onClick={handleAddClick}>
              Add Stock Split
            </button>
          </div>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Stock Name</th>
                <th>New Name</th>
                <th>Status</th>
                <th>Split Date</th>
                <th>Split Ratio</th>
                <th>Sourced On</th>
                <th>Created On</th>
                <th>Corporate Action</th>
                <th>Source Action</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item, index) => (
                <tr key={item.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{item.stockname}</td>
                  <td>{item.newname}</td>
                  <td>{item.status === 1 ? "Completed" : "Pending"}</td>
                  <td>{item.splitdate}</td>
                  <td>{item.splitratio}</td>
                  <td>{item.sourcedon}</td>
                  <td>{item.createdon}</td>
                  <td>{item.corporateaction}</td>
                  <td>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default anchor behavior
                        handleSourceClick();
                      }}
                     target="_blank" rel="noopener noreferrer"
                    >
                      Source Data
                    </a>
                  </td>
                  <td>
                    <button className="btn btn-secondary" onClick={() => handleEditClick(item)}>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination Controls */}
          <nav className="d-flex justify-content-center mt-3">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>
              {pageNumbers.map((number) => (
                <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => paginate(number)}>
                    {number}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === pageNumbers.length}
                >
                  Next
                </button>
              </li>
            </ul>
            {/* Items per page dropdown */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <label className="me-2">Show{' '}</label>
            <select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              className="form-select d-inline-block w-auto"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
            <label className="ms-2">entries</label>
          </div>
          </nav>

          

          {showAddModal && (
            <AddStockSplitForm onClose={closeModals} corporateActions={getUniqueCorporateActions(data)} />
          )}
          {showEditModal && selectedItem && (
            <EditStockSplitForm onClose={closeModals} item={selectedItem} corporateActions={getUniqueCorporateActions(data)} />
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default StockSplitCalendar;
